import React from 'react'

const PrivateRoutes = () => {
  return (
    <div>
      
    </div>
  );
};

export default PrivateRoutes
